module.exports = __webpack_public_path__ + "static/media/9_RoomControls_WallLight_HL.141fc681.png";